// Feuille de style d'impression de la progression annuelle, partagée par les deux
// surfaces qui produisent le même document : /app/progressions (connecté) et
// /generateur-progression-annuelle (anonyme). Elles divergeaient — crème d'un
// côté, gris Google de l'autre — et un même enseignant n'imprimait pas la même
// page selon qu'il était connecté. Source unique, aux hex du design system
// (les tokens CSS ne résolvent pas dans la fenêtre d'impression détachée).
//
// th = warm-surface (l'en-tête de colonne, structure) ; .row-header = encre-pale
// (l'intitulé de ligne porte l'information de référence).

/** Document A4 paysage écrit dans la fenêtre `window.open()` de l'impression. */
export const PROGRESSION_PRINT_CSS = `@page { size: A4 landscape; margin: 1.5cm; }
body { font-family: 'DM Sans', Arial, sans-serif; font-size: 9pt; color: #11131d; margin: 0; }
h2 { font-size: 13pt; margin: 0 0 3pt; }
.subtitle { font-size: 9pt; color: #525252; margin: 0 0 14pt; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #dedede; padding: 4pt 5pt; vertical-align: top; font-size: 8pt; }
th { background-color: #f2f2f2; font-weight: bold; text-align: center; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
.row-header { font-weight: 600; width: 72pt; background-color: #e3ebfd; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
ul { margin: 0; padding-left: 12pt; }
li { margin-bottom: 2pt; }`;

/** Bloc `@media print` injecté dans la page, pour l'impression du tableau en place. */
export const PROGRESSION_PRINT_MEDIA_CSS = `@media print {
	.print-hidden { display: none !important; }
	@page { size: A4 landscape; margin: 1.5cm; }
	body { font-size: 10pt; color: #11131d; }
	.progression-table { width: 100%; border-collapse: collapse; font-size: 8.5pt; }
	.progression-table th, .progression-table td { border: 1px solid #dedede; padding: 4pt 5pt; vertical-align: top; }
	.progression-table th { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-weight: bold; text-align: center; }
	.progression-table .row-header { background-color: #e3ebfd !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-weight: 600; white-space: nowrap; width: 80pt; }
	.progression-table ul { margin: 0; padding-left: 12pt; }
	.progression-table li { margin-bottom: 2pt; }
}`;
